module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-3.bf2beda8.png";